import type { SVGProps } from 'react'
const LineCheck = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M8.75 18.29c-.32 0-.64-.12-.885-.365l-4.645-4.65 1.06-1.06 4.47 4.47 10.97-10.97 1.06 1.06L9.635 17.92a1.25 1.25 0 0 1-.885.365z"
		/>
	</svg>
)
export { LineCheck }
